import PatientPaymentHistoryPage from "../../../payment/pages/PatientPaymentHistory/PatientPaymentHistoryPage";

export default function AssistantPaymentHistoryPage() {
  return <PatientPaymentHistoryPage role="assistant" />;
}